import { useContext } from 'react';
import { useLocation, useParams } from 'react-router';
import { store } from 'components/Store';
import { useMainActionsBarFunctions } from 'components/Dashboard/SubNav/MainListActionsBar';
import { useContentResults } from 'components/Dashboard/ContentResultsContext';

const unseenNumbers = {
  KeyUpdates: { unseenNumber: 'KeyUpdate', lastSeenMarker: 'keyUpdateFeedItemId' },
  Consultations: { unseenNumber: 'Consultation', lastSeenMarker: 'consultationFeedItemId' },
  Legislation: { unseenNumber: 'Legislation', lastSeenMarker: 'legislationFeedItemId' },
  ParliamentLive: { unseenNumber: 'ParliamentLive', lastSeenMarker: 'parliamentLiveFeedItemId' },
  ParliamentaryRecord: { unseenNumber: 'ParliamentaryRecord', lastSeenMarker: 'parliamentaryRecordFeedItemId' },
  CommitteePublications: { unseenNumber: 'CommitteePublications', lastSeenMarker: 'committeePublicationFeedItemId' },
  LibraryMaterial: { unseenNumber: 'CommonsLibraryArticle', lastSeenMarker: 'commonsLibraryArticleFeedItemId' },
  SocialMedia: { unseenNumber: 'Tweet', lastSeenMarker: 'tweetFeedItemId' },
  Influence: { unseenNumber: 'UserContent', lastSeenMarker: 'userContentFeedItemId' },
  UpcomingEvents: { unseenNumber: 'Event', lastSeenMarker: 'eventFeedItemId' },
  Regulations: { unseenNumber: 'RegulationDocument', lastSeenMarker: 'regulationDocumentFeedItemId' },
};

const useRememberPosition = () => {
  const globalState = useContext(store);
  const { state, dispatch } = globalState;
  const location = useLocation();
  const params = useParams();
  const { mainSection } = params;

  const { contentResults, setContentResults, lastSeenMarkers, itemsViewed, setFeedState } = useContentResults();
  const { unseenNumbersCurrentList, search } = state;
  const { list } = search;

  const { setTemporarySelectedUpdates } = useMainActionsBarFunctions();

  const rememberPosition = (section, scrollBarRef, index) => {
    let currentSection = contentResults[section];
    let sectionUnseenProperties = unseenNumbers[section];
    let { unseenNumber, lastSeenMarker } = sectionUnseenProperties ?? {};
    let newSectionObject = { ...currentSection };
    const feedItem = newSectionObject?.feedItemFlags?.[index];
    const isBackpopulatedCondition = feedItem?.isBackpopulated === null || feedItem?.isBackpopulated === true;

    let unseenItem =
      !!lastSeenMarkers[lastSeenMarker] &&
      lastSeenMarkers[lastSeenMarker] < feedItem?.feedItemId &&
      !isBackpopulatedCondition;

    if (!!list && unseenItem) {
      newSectionObject.feedItemFlags[index].feedItemId = -1;
    }

    if (scrollBarRef?.current) {
      newSectionObject = {
        ...newSectionObject,
        scrollPosition: scrollBarRef?.current?.view?.scrollTop ?? 0,
        listSection: mainSection,
      };
    }

    let newResults = {
      ...contentResults,
      [section]: newSectionObject,
    };
    if (!!list && unseenItem) {
      let newUnseenNumbers = { ...unseenNumbersCurrentList };
      newUnseenNumbers[unseenNumber] = (newUnseenNumbers[unseenNumber] ?? 0) - 1;
      let item = newSectionObject?.hits?.[index];
      let newItemsViewed = [...itemsViewed];
      if (!newItemsViewed.includes(item?.objectID)) {
        newItemsViewed.push(item?.objectID);
      }
      setFeedState('itemsViewed', newItemsViewed);
      dispatch({ type: 'MODIFY_SECTION', parameter: 'unseenNumbersCurrentList', value: newUnseenNumbers });
    }
    if (scrollBarRef) {
      dispatch({
        type: 'MODIFY_SECTION',
        parameter: 'clickedOnContentUrl',
        value: `${location.pathname}${location.search}${location.hash}`,
      });
    }
    setContentResults(newResults);
    setTemporarySelectedUpdates();
  };

  return { rememberPosition };
};

export { unseenNumbers };
export default useRememberPosition;
